module.exports = __webpack_public_path__ + "img/potato.be5030ca.webp";